import { channels } from "../models/Channels";
import { countriesEnum } from "../models/EnumEntity";
import { OrderOperationStates } from "../models/OrderEntity";
import { paymentMethods } from "../models/PaymentMethods";
import { PaymentStates } from "../models/PaymentStates";

export const getCardPaymentsToRefundFromOrder = (order) => {
    const cardPayments = order.payments
        ?.filter(x => (x.paymentMethodType === paymentMethods.Card || x.paymentMethodType === paymentMethods.Posnet) && 
                      (x.state === PaymentStates.Approved || x.state === PaymentStates.PartiallyRefunded))
      
    return cardPayments?.filter(payment => {
        if (payment.state === PaymentStates.Approved) return true;
        
        const suma = order
            .operations?.filter(o => o.type !== "Invoice")
            .operations?.filter(o => o.state === OrderOperationStates.Approved)
            .flatMap(o => o.payments)
            .filter(p => p.paymentId === payment.paymentId)
            .reduce((acumAmount, operationPayment) => acumAmount + operationPayment.amount, 0);

        return suma < payment.amount;
    });
};

const hasCountryTerminal = country =>
    country === countriesEnum.AR || country === countriesEnum.UY 

export const hasBusinessTerminal = (country, isFranchise) =>
    hasCountryTerminal(country) && !isFranchise

export const isTerminalPV = (country, isFranchise, hasTerminal) =>
    hasBusinessTerminal(country, isFranchise) && hasTerminal

export const hasTerminalQrPayment = order =>
    hasCountryTerminal(order.country) &&
    order.channel === channels.values.Tienda &&
    order.payments.some(p => p.state === PaymentStates.Approved && p.paymentMethodType === paymentMethods.TerminalQr)

export const hasTerminalPayment = (order) =>
    hasCountryTerminal(order.country) &&
    order.channel === channels.values.Tienda &&
    order.payments.some(p => (p.state === PaymentStates.Approved || p.state === PaymentStates.PartiallyRefunded) && p.paymentMethodType === paymentMethods.Posnet && p.isTerminal)

export const hasIndeterminatePosnetPayment = (order) =>
    hasCountryTerminal(order.country) &&
    order.channel === channels.values.Tienda &&
    order.payments.some(p => (p.state === PaymentStates.Approved || p.state === PaymentStates.PartiallyRefunded) && p.paymentMethodType === paymentMethods.Posnet &&
                             (p?.isTerminal === undefined || p?.isTerminal === null))

export const filterCardPaymentsByRefundAmount = (cardPayments, hasTerminal, refundAmount) => {
    if (!hasTerminal || refundAmount <= 0) return cardPayments;

    return cardPayments.filter(payment => payment.amount >= refundAmount);
}

export const TerminalPvBlockers = {
    InvalidPvForTerminalQr: "InvalidPvForTerminalQr",
    InvalidPvForTerminal: "InvalidPvForTerminal",
}

/**
 * Determina si el PV actual puede operar la terminal integrada para esta orden.
 * Concentra las tres condiciones que habilitan la operación: país con terminal integrada,
 * negocio no franquiciado con terminal asociada, y —cuando hay pago de Terminal QR— que el
 * PV sea el mismo donde se cobró.
 *
 * @param order orden cruda de la API (sin mapear)
 * @param validateQrBillingCode false solo para operaciones que sales-api ya rechaza por tipo
 *        sobre Terminal QR (cambios y devoluciones parciales), donde el PV del pago QR es
 *        irrelevante porque la operación nunca llega a procesarlo.
 * @returns la clave del modal que bloquea la operación, o null si se puede operar.
 */
export const getTerminalPvBlocker = (order, { pv, business, validateQrBillingCode = true }) => {
    if (validateQrBillingCode && hasTerminalQrPayment(order) && order.billingCode !== pv.billingCode)
        return TerminalPvBlockers.InvalidPvForTerminalQr;

    if (!isTerminalPV(business.country, business.isFranchise, pv.hasTerminal) &&
        (hasTerminalQrPayment(order) || hasTerminalPayment(order)))
        return TerminalPvBlockers.InvalidPvForTerminal;

    return null;
}